import { action, isAbortError } from '@reatom/framework'

import { Option, Result } from '@blade/std-lib'
import { UnknownError } from '@root/shared'

import * as KnownSocialPlatformResource from '../model/known-social-platform-resource'
import { TiktokPostOembed } from '../model/tiktok-post-oembed'

interface GetTiktokPostOembedRequestActionParams {
  resource: KnownSocialPlatformResource.TiktokKnownSocialPlatformResource<'tiktok'>
}

export const getTiktokPostOembedRequestAction = action(
  async (
    ctx,
    params: GetTiktokPostOembedRequestActionParams,
  ): Promise<Result.Result<TiktokPostOembed, UnknownError>> => {
    try {
      const oembedUrl = KnownSocialPlatformResource.toTiktokOembedUrl(
        params.resource,
      )

      const response = await ctx.schedule(() => fetch(oembedUrl.toString()))

      if (!response.ok) {
        return Result.fail(
          UnknownError.fromUnknown(
            `TikTok oembed request failed: ${response.status}`,
          ),
        )
      }

      const json = (await ctx.schedule(() => response.json())) as unknown

      const decoded = TiktokPostOembed.decode(json)

      if (Option.isNone(decoded)) {
        return Result.fail(
          UnknownError.fromUnknown('Failed to decode tiktok post oembed'),
        )
      }

      return Result.succeed(decoded.value)
    } catch (error) {
      if (isAbortError(error)) {
        throw error
      }
      return Result.fail(UnknownError.fromUnknown(error))
    }
  },
  'getTiktokPostOembedRequestAction',
)
